import { SvgIconsMap } from '@design';

export const isValidIcon = (name: string): name is keyof typeof SvgIconsMap =>
  name in SvgIconsMap;
